import { render, staticRenderFns } from "./file1.vue?vue&type=template&id=4c6afec0&scoped=true"
import script from "./file1.vue?vue&type=script&lang=js"
export * from "./file1.vue?vue&type=script&lang=js"
import style0 from "./file1.vue?vue&type=style&index=0&id=4c6afec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c6afec0",
  null
  
)

export default component.exports